export type AssignmentRuleKind = 'None' | 'IntakeQueue' | 'SpecificAgent' | 'RoundRobin';

export class AssignableAgentEntity {
  public userId!: string;
  public firstName!: string;
  public lastName!: string;
  public email!: string;
  public isManager!: boolean;
  public teamIds!: string[];
}

export class CaseAssignmentOptionsEntity {
  public caseTypeId!: string;
  public ruleKind!: AssignmentRuleKind;
  public teamId!: string | null;
  public suggestedPrimaryUserId!: string | null;
  public allowsPrimaryEdit!: boolean;
  public allowsSecondary!: boolean;
  public candidateAgents!: AssignableAgentEntity[];
}
